<template>
  <ElContainer class="full-window">
    <ElHeader height="60px" class="bg-blue-500 text-white">
      <div class="h-full w-full flex items-center justify-between">
        <div class="font-bold text-lg flex items-center gap-2">
          <ElIcon size="28" class="relative"><Ship /></ElIcon>
          闽江航道数据管理平台
        </div>

        <div class="layout-nav">
          <el-link :underline="false">首页</el-link>
          <el-link href="https://manager.wisionic.com/manage/navigatmark/navigate" target="_blank" :underline="false"
            >管理</el-link
          >
          <el-link href="https://jtyst.fujian.gov.cn/fjgh/ " target="_blank" :underline="false"
            >更多服务</el-link
          >
        </div>

        <div>
          <div v-if="!userStore.isLogin" class="login-btn">
            <span>注册 </span> | <span @click="loginModelRef.openModel()"> 登录</span>
          </div>

          <el-dropdown @command="handleCommand" trigger="click" v-else>
            <span class="flex items-center" style="color: #fff; font-size: 16px">
              {{ userStore.userInfo?.userName }}
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </span>

            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="tcdl">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </ElHeader>
    <ElMain class="p-0 relative overflow-hidden" style="background-color: rgb(188, 188, 188)">
      <RouterView style="width: 100%; height: 100%" />
      <LoginModel ref="loginModelRef" />
    </ElMain>
  </ElContainer>
</template>

<script lang="ts" setup>
import { Ship, ArrowDown } from '@element-plus/icons-vue'
import { useUserStore } from '@/stores/user'
import { ElMessageBox } from 'element-plus'
import { ref } from 'vue'
import LoginModel from './components/LoginModel.vue'

const userStore = useUserStore()
const loginModelRef = ref() // 登录弹窗

const handleCommand = (command: string) => {
  if (command === 'tcdl') {
    ElMessageBox.confirm('确定要退出登录吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      userStore.userLogoutHandler().then(() => {
        window.location.reload()
      })
    })
  }
}
</script>

<style scoped lang="scss">
.login-btn {
  span {
    cursor: pointer;
  }
}

.layout-nav {
  display: flex;
  height: 100%;
  .el-link {
    height: 100%;
    width: 168px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 17px;
    cursor: pointer;
    color: #fff;
    &:hover {
      background-color: #fff;
      color: #3b82f6;
    }
    &:first-child {
      background-color: #fff;
      color: #3b82f6;
    }
  }
}
</style>
